import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { paths } from '@/routes/paths';

/**
 * Gate for authenticated areas. Redirects to /login (preserving the intended
 * destination) when there is no session. Bootstrapping is handled upstream by
 * AuthProvider, so by the time this renders status is resolved.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const status = useAuthStore((s) => s.status);
  const sessionExpired = useAuthStore((s) => s.sessionExpired);
  const location = useLocation();

  if (status !== 'authenticated') {
    const params = new URLSearchParams();
    if (location.pathname && location.pathname !== paths.root) {
      params.set('redirect', location.pathname + location.search);
    }
    if (sessionExpired) params.set('expired', '1');
    const query = params.toString();
    return <Navigate to={`${paths.login}${query ? `?${query}` : ''}`} replace />;
  }

  return <>{children}</>;
}
